import { UserRole } from "../../Profile/enums/profileEnums";

/**
 * Portal nav visibility derived from backend `@PreAuthorize` / `@Secured` on the
 * services the container MFEs call. Update when controllers change.
 */

type RoleInput = UserRole | undefined;

/** Identity IMS `AnalyticsController` — constant `DASHBOARD_ROLES` on GET `/analytics/*`. */
export function canAccessDashboardAnalytics(role: RoleInput): boolean {
  if (role == null) return false;
  return (
    role === UserRole.COMPANY_ADMIN ||
    role === UserRole.STORE_ADMIN ||
    role === UserRole.WAREHOUSE_MANAGER ||
    role === UserRole.SALES_PROCUREMENT
  );
}

/**
 * Products & catalog — `ProductController` POST `/api/products/list` and `/api/products/detail`
 * (same role set as category list below).
 */
export function canAccessProductCatalog(role: RoleInput): boolean {
  if (role == null) return false;
  return (
    role === UserRole.COMPANY_ADMIN ||
    role === UserRole.STORE_ADMIN ||
    role === UserRole.WAREHOUSE_MANAGER ||
    role === UserRole.INVENTORY_CLERK ||
    role === UserRole.SALES_PROCUREMENT
  );
}

/** Products & category — `CategoryController` POST `/api/categories/list-by-company`. */
export function canAccessCategoryList(role: RoleInput): boolean {
  return canAccessProductCatalog(role);
}

/**
 * Store sales orders — inventory `OrderReservationController` uses this role set;
 * OMS `OrderController` GET `/api/orders/by-store` has no method-level `@PreAuthorize`
 * (authenticated + service checks only).
 */
export function canAccessStoreSalesOrdersNav(role: RoleInput): boolean {
  return canAccessProductCatalog(role);
}

/**
 * Store-scoped finance lists — OMS `PaymentController` / `InvoiceController` / `ReceiptController`
 * `.../by-store` and similar paths are authenticated-only at method level; company-wide
 * list endpoints use `hasRole('COMPANY_ADMIN')`. Non–company-admin users rely on store routes.
 */
export function canAccessStoreFinanceNav(role: RoleInput): boolean {
  if (role == null) return false;
  return role !== UserRole.COMPANY_ADMIN;
}
